import {LocationType, PhysicalLocationType, PickingStrategy} from './models-binLocation';
import {BlockForQcType, ToleranceType} from './models-item';

export type ConfirmProductionAutoPrintLabelsStyle = 'NONE' | 'ASK' | 'ALWAYS';
export const ConfirmProductionAutoPrintLabelsStyleValues: ConfirmProductionAutoPrintLabelsStyle[] = ['NONE' , 'ASK' , 'ALWAYS'];

export interface ICounting {
  allowSimpleConfirmForNextLocation: boolean;
  batchCountingShowItemQuantitiesOnLocation: boolean;
  batchCountingShowItemsOnLocation: boolean;
  countingAllowAnyLocation: boolean;
  countingReasons: string[];
  countingShowItemQuantitiesOnLocation: boolean;
  countingShowItemsOnLocation: boolean;
  countingUnmarkedLocationDefaultFullLocationCounting: boolean;
  doNotScanBatches: boolean;
  guidedCounting: boolean;
  recounterOneShowQuantities: boolean;
  recounterThreeShowQuantities: boolean;
  recounterTwoShowQuantities: boolean;
  wtwEmptyBinLocationItemCode: string;
  wtwStrategy: WallToWallStrategy;
}

export interface IDelivery {
  allowFinishWithoutLabelPrinting: boolean;
  batchDeliveryScriptSource: string;
  deliveryDispatchGroups: IDelivery$IDeliveryDispatchGroup[];
  deliveryDispatchRequireScanningContainers: boolean;
  deliveryReportContexts: IDelivery$IDeliveryReportContext[];
  enableDeliveryDispatchApplication: boolean;
  groupDeliveriesForDispatch: boolean;
  groupDeliveriesForDispatchEnforceOrder: boolean;
  mobilePackingUiSimple: boolean;
  packingSlipDefaultStartDateSubtract: number;
  packingSlipDirectSearch: boolean;
  packingSlipHideItemLabelPrintButton: boolean;
  shippingContainers: IDelivery$IShippingContainer[];
  showPrintPreDeliveryDocumentsButtonOnPackAndDelivery: boolean;
  splitPackAndDelivery: boolean;
}

export interface IDelivery$IDeliveryDispatchGroup {
  name: string;
}

export interface IDelivery$IDeliveryReportContext {
readonly   defaultForDelivery: boolean;
readonly   defaultForDeliveryDispatch: boolean;
  isDefaultForDelivery: boolean;
  isDefaultForDeliveryDispatch: boolean;
  name: string;
}

export interface IDelivery$IShippingContainer {
  extra: {[key: string] :Object};
  itemCode: string;
  type: string;
}

export interface IGoodsReceipt {
  allowOverReceiving: boolean;
  allowQuickFill: boolean;
  enableSelectButtonForGoodsReceipt: boolean;
  goodsReceiptSelectLineIfMultipleAreAvailableForItem: boolean;
  goodsSortingOnIssueNotificationType: string;
  includeDrafts: boolean;
  includePurchaseOrders: boolean;
  includeReceiptLocationInStockStorage: boolean;
  includeSalesOrders: boolean;
  printLabelsOnReceipt: boolean;
  printLabelsOnScanStyle: PrintLabelsOnScanStyle;
  printReportOnReceipt: boolean;
}

export interface IImporters {
  importerScript: string;
  savePurchaseOrderAsDraft: boolean;
  savePurchaseOrderAsNotConfirmed: boolean;
  saveSalesOrderAsNotConfirmed: boolean;
}

export interface IKanban {
  labelColors: IKanban$IKanbanLabelColor[];
}

export interface IKanban$IKanbanLabelColor {
  color: string;
}

export interface IObjectDefaults {
  binLocationConfirmMovementIfNotEmpty: boolean;
  binLocationLocationType: LocationType;
  binLocationPhysicalLocationType: PhysicalLocationType;
  binLocationPickingStrategy: PickingStrategy;
  itemBlockForQcType: BlockForQcType;
  itemProductionMaterialToleranceType: ToleranceType;
  itemProductionMaterialToleranceValue: number;
  itemReceiptScanExpDate: boolean;
  itemReceiptScanMnfBatch: boolean;
  itemReceiptScanMnfDate: boolean;
  itemReceiptScanMnfSerial: boolean;
  itemSerialManagedByDispatch: boolean;
}

export interface IPickAndCollect {
  askForPrintLocationLabelOnAutoSelectButton: boolean;
  autoConvertPackLocationsToContainers: boolean;
  autoCreateLocationOnNoFreePackLocations: boolean;
  autoSelectCollectionLocation: boolean;
  enableAutoSelectPackLocationButton: boolean;
  singleLocationPicking: boolean;
}

export interface IPicking {
  allowClearingPicklistsAtDelivery: boolean;
  directlySendToPackingOnFinish: boolean;
  markPicklistPickedAfterPickAndCollect: boolean;
  quantityStateStartsAtOne: boolean;
  requireTargets: PickingRequireTargetsMode;
  scanTargetMode: PickingScanTargetMode;
}

export interface IPicklistGenerator {
  alwaysExpandUntilLevel: number;
  auto: IPicklistGenerator$IAuto;
  directSearch: boolean;
  fromBulkAndPickButton: boolean;
  onlyFromPickButton: boolean;
  pushPicklistToKardexOnCreation: boolean;
  releaseToPickAndCollectButton: boolean;
  searchDefaultDateRangeEndAdd: number;
  searchDefaultDateRangeStartSubtract: number;
  searchDefaultFilter: string;
  useDateFilter: boolean;
}

export interface IPicklistGenerator$IAuto {
  createOnlyIfFullyInPicking: boolean;
  enabled: boolean;
  interval: number;
  maxDateOffset: number;
  minDateOffset: number;
  minimumPrice: number;
  printer: number;
  runFrom: any;
  runTo: any;
}

export interface IProduction {
  confirmProductionAutoPrintLabelsStyle: ConfirmProductionAutoPrintLabelsStyle;
  confirmProductionScrapLocation: string;
  confirmProductionWarnOnOverProduction: boolean;
  enableLicensePlates: boolean;
  enableMixingLocations: boolean;
  enableProductionConfirmationWithinMaterialConfirmation: boolean;
  materialConfirmationRequireCollectionLocation: boolean;
  materialConfirmationScanOriginalLocationOnFinish: boolean;
  materialConfirmationShowInventoryBatchHints: boolean;
  materialConfirmationWarnAtOverIssue: boolean;
}

export interface IStockTransfer {
  allowAlternativeFromLocationReplenishment: boolean;
  groupRequestsBasedOnFromLocationReplenishment: boolean;
  requireScanningReturnLocationAfterReplenishment: boolean;
}

export type PickingRequireTargetsMode = 'NEVER' | 'ONLY_BATCH_PICKING' | 'ALWAYS';
export const PickingRequireTargetsModeValues: PickingRequireTargetsMode[] = ['NEVER' , 'ONLY_BATCH_PICKING' , 'ALWAYS'];

export type PickingScanTargetMode = 'NEVER' | 'ONLY_BATCH_PICKING' | 'ALWAYS';
export const PickingScanTargetModeValues: PickingScanTargetMode[] = ['NEVER' , 'ONLY_BATCH_PICKING' , 'ALWAYS'];

export type PrintLabelsOnScanStyle = 'NONE' | 'ASK' | 'ALWAYS';
export const PrintLabelsOnScanStyleValues: PrintLabelsOnScanStyle[] = ['NONE' , 'ASK' , 'ALWAYS'];

export type WallToWallStrategy = 'SINGLE_COUNTING' | 'DOUBLE_COUNTING_ALL' | 'DOUBLE_COUNTING_ONLY_WRONG';
export const WallToWallStrategyValues: WallToWallStrategy[] = ['SINGLE_COUNTING' , 'DOUBLE_COUNTING_ALL' , 'DOUBLE_COUNTING_ONLY_WRONG'];

